<script>
    import { popupAction } from '../../components/popup-action.js';

    export let message = '';
</script>

<i class="fa fa-info-circle" style="color: #3F66DA;" data-toggle="confirmation"
    use:popupAction={{
        rootSelector: '[data-toggle=confirmation]', 
        singleton: true,
        popout: true,
        placement:'right',     
        template:`<div class="popover" role="tooltip">
            <div class="arrow"></div>
                <div class="popover-body">
                    ${message}
                </div>
            </div>` 
    }}
/>